// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { onMounted } from 'vue'
import hybridPage from '@/lib/hybridPage'
import {
	createGAEvent,
	GaGeneralEvent,
	GaGeneralPageName,
} from '@/assets/ts/customEvent'
import { setCurrentGaPageName, getCurrentGaPageName } from '@/lib/utils'
import InvitePage from '@/pages/invite/components/_InvitePage.vue'
import InviteSuccessPage from '@/pages/invite/components/_InviteSuccessPage.vue'
import { getSiteBaseUrl, getMcrRootUrl } from '@/lib/siteBaseUrl'
import { checkIsNewReferralFlow } from '@/lib/checkService'

export interface InvitePageContent {
	heroContent: {
		title: string
		description: string
		ctaButton: string
	}
	rewardProcessContent: {
		steps: {
			title: string
			description: string
		}[]
	}
	valuePropositionContent: {
		title: string
		items: {
			title: string
		}[]
	}
	otherInformationContent: {
		availBrandsText: string
		signUpText: string
		ctaButton: string
	}
	inviteSuccessContent: {
		welcomeText: string
		title: string
		description: string
		ctaButtonPrimary: string
		ctaButtonSecondary: string
	}
}

hybridPage()

createApp({
	name: 'Invite',
	components: {
		InvitePage,
		InviteSuccessPage,
	},
	setup() {
		const invitePageContent = window.pageContent
		const isShowInvitePage =
			!!window.BUYANDSHIP.settings.member_invite &&
			!window.BUYANDSHIP.settings.user_id &&
			checkIsNewReferralFlow()
		const isShowInviteSuccessPage =
			!!window.BUYANDSHIP.settings.user_id &&
			!!localStorage.getItem('show_invite_success_page') &&
			checkIsNewReferralFlow()

		const trackInvitePageLoad = () => {
			setCurrentGaPageName(GaGeneralPageName.InvitePage)
			createGAEvent(GaGeneralEvent.PageLoad, {
				page_name: getCurrentGaPageName(),
			})
		}

		onMounted(() => {
			if (window.BUYANDSHIP.settings.user_id && !isShowInviteSuccessPage) {
				// Show error dialog on MCR referral page
				window.location.href = `${getMcrRootUrl()}/account/referral/?refer=invitePage&referSuccess=no`
				return
			}

			if (!isShowInvitePage && !isShowInviteSuccessPage) {
				const baseUrl = getSiteBaseUrl()
				window.location.href = import.meta.env.DEV
					? `${import.meta.env.PUBLIC_ROOT_URL}/index`
					: baseUrl
				return
			}

			trackInvitePageLoad()
		})

		return {
			invitePageContent,
			isShowInvitePage,
			isShowInviteSuccessPage,
		}
	},
}).mount('#bsMain')
